"use client"

import ToFAQ from "@/components/Category/ToFAQ";
import CTA from "@/components/CTA";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopJakarta: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-4">Kenapa Sewa Laptop Jakarta Lebih Masuk Akal Daripada Beli</h2>

    <p className="mb-4">
      Dalam dunia serba cepat seperti Jakarta, <strong>sewa laptop Jakarta</strong> bukan sekadar alternatif, ini strategi efisiensi.
      Ketika kebutuhan datang tiba² dan anggaran harus dijaga, <strong>sewa laptop Jakarta</strong> menjadi solusi cerdas: fleksibel, praktis, dan bebas dari risiko biaya perawatan.
    </p>

    <div className="grid gap-6">
      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Cakupan Area Lengkap se-Jakarta</h3>
        <p>
          Butuh <strong>sewa laptop Jakarta</strong> di SCBD, Kuningan, Kemang, atau bahkan Cengkareng? Kami hadir di seluruh Jakarta: Selatan, Pusat, Barat, Utara, hingga Timur.
          Kamu tinggal pilih tipe dan spek laptop, kami kirim.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Laptop Ready Pakai: Clean, Update, & Stabil</h3>
        <p>
          Setiap unit <strong>laptop sewaan Jakarta</strong> kami sudah preload software standar, OS terupdate, dan rutin di-maintain. Tanpa virus, tanpa delay.
          Laptop ngadat? Kami ganti. Kamu fokus kerja, kami urus sisanya.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Gratis Ongkir Jakarta²</h3>
        <p>
          Pengiriman <strong>sewa laptop Jakarta</strong> GRATIS ke semua titik: dari kosan mahasiswa di Rawamangun sampai ballroom hotel bintang lima di Sudirman.
          Tanpa minimum, tanpa delay.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Dukungan 24 Jam</h3>
        <p>
          Kami ngerti, Jakarta nggak tidur. Support <strong>sewa laptop Jakarta</strong> kami juga nggak tidur. Butuh bantuan malam²? Chat atau call saja. Kami ready 24/7.
        </p>
      </div>

      <div className="bg-white p-6 rounded-2xl shadow border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Harga Bisa Nego, Spek Bisa Custom</h3>
        <p>
          Laptop Core i5? i7? RAM 8GB atau 32GB? Kamu butuh untuk desain grafis, presentasi, atau pelatihan skala besar?
          Tim kami siap bantu sesuai spek dan budget. Harga <strong>sewa laptop Jakarta</strong> fleksibel & transparan.
        </p>
      </div>
    </div>

    <h2 className="text-xl font-bold mt-8 mb-3">Mobilitas: Kami Jemput, Kami Antar</h2>
    <p className="mb-4">
      Mau sewa dari coworking space di Blok M, rumah di Tebet, atau event hall di Kelapa Gading? Tim logistik kami akan handle.
      <strong>Sewa laptop Jakarta</strong> makin simpel karena kamu nggak perlu keluar rumah.
    </p>

    <h2 className="text-xl font-bold mb-3">Durasi Fleksibel: Harian², Mingguan², Bulanan²</h2>
    <p className="mb-4">
      Mau trial 1 hari atau butuh laptop selama 3 bulan penuh? Kami support semua. Sistem <strong>sewa laptop Jakarta</strong> kami dirancang tanpa ikatan kontrak jangka panjang. Bebas dan fleksibel.
    </p>

    <h2 className="text-xl font-bold mb-3">Backup dan Garansi Sepanjang Sewa</h2>
    <p className="mb-4">
      Gangguan teknis? Kami langsung ganti unit. Rutin maintenance dan selalu ada stok cadangan.
      Kamu nggak akan ditinggal saat butuh. <strong>Sewa laptop Jakarta</strong> yang beneran bisa diandalkan.
    </p>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Laptop"
    />

  </>
);

export default laptopJakarta;